import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import {RESOURCE_BASE_URL} from "../../../../../configuration";
import axios from "axios";
import NoticeItem from "../../../HomeContent/InformationNotice/NoticeItem/NoticeItem";
import TreeViewMenu from "../../../HomeContent/InformationNotice/ArticleItem/TreeViewMenu";
import './Beginners.css'
import MetaTags from "react-meta-tags";

class InformationList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userId: props.userId,
            articles: [],
            totalItemCount: 0,
            activePage: 1
        };
        this.getArticles = this.getArticles.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        this.getArticles();
    }

    getArticles = (offset, limit) => {
        offset = 0;
        limit = 10000;
        axios.get(RESOURCE_BASE_URL + 'api/articles?offset=' + offset + '&limit=' + limit)
            .then((res) => {

                // console.log("aaaaaaaaaaaaaaaaaaaaaaa article list ",res.data.articles.content);
                this.setState({
                    articles: res.data.articles.content,
                    totalItemCount: res.data.rowCount
                });
                // console.log(res.data);
            })
            .catch((err) => {
                this.setState(
                    {
                        inquiries: []
                    });
                console.log("[API] ERROR: ", err);
            });
    };


    render() {
        let sortJsonArray = require('sort-json-array');
        let sortedArticles = sortJsonArray(this.state.articles, 'createdDate', 'des');
        return (
            <div className="faq-page-layout">
                <MetaTags>
                    <title>インフォメーション｜プリント基板のネット通販｜KITCUT PCB</title>
                    <meta property="title" content="インフォメーション｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta name="title" content="インフォメーション｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta property="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                    <meta name="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                </MetaTags>
                <div className="beginners-background-div ">
                    {/*<div className="user-inquiry-content">*/}
                        {/*<div id="info-list-div">*/}
                            <div className="title-1 text-align-left info-font-size">
                                <FormattedMessage id="app.info-list.title"
                                                  defaultMessage="Information"
                                                  description=""/>
                            </div>

                            <hr/>
                            <div className="row information-div">

                                <div className="notice-items all-content-font-size notice-items-responsive">
                                    {this.state.articles.length === 0 &&
                                    <label className="center-align"><FormattedMessage id="app.info-list.no-info"
                                                                                      defaultMessage="No Information to display at the moment"
                                                                                      description=""/></label>

                                    }

                                    {sortedArticles.map(article => {
                                        return <NoticeItem article={article}/>;

                                    })}


                                </div>

                            </div>

                        {/*</div>*/}
                    {/*</div>*/}
                </div>
            </div>

        )
    }
}

export default InformationList;



// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/InformationList.js